import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { httpGet, httpPost } from "../../services/httpService";
import {
  addCompanySubscriptionUrl,
  addPromotionalCreditUrl,
  GetCompanyLedgerSummaryUrl,
  GetCompanyLedgerPurchaseHistoryUrl,
  getCompanySubscriptionsUrl,
  getTrackServiceBillingUrl,
  getGoCardlessBillingRequestUrl,
  getCompanyInvoicesByCompanyIdUrl,
  updateCompanySubscriptionUrl,
  getCompnayUserCountUrl,
  UpdateCompanySubscriptionSiteLicensesUrl,
  getCompanySubscriptionCostsUrl
} from "../../apiUrls/apiUrls";

const initialState = {
  isCompanyServicesBilling: false,
  companyServicesBilling: [],
  addCompanySubscriptionLoading: false,
  companySubscription: null,
  isCompanySubscriptionloading: false,
  isGoCardlessRequestLoading: false,
  goCardlessRequestData: null,
  isCompanyLedgerSummaryloading: false,
  isCompanyLedgerPurchaseHistoryLoading: false,
  companyLedgerSummary: null,
  companyPurchaseHistory: null,
  companyInvoices: null,
  iscompanyInvoicesloading: false,
  updateCompanySubscription: null,
  isSubscriptionUpdating: null,
  companyUserCount: "",
  updateCompanySubscriptionForLicenses: null,
    isCompanySubscriptionCostsLoading: false,
  companySubscriptionCosts: null,
};

export const getTrackServiceBillingData = createAsyncThunk(
  "companyServiceBilling/getTrackServiceBillingData",
  async (params, thunkApi) => {
    const { companyId } = params;
    const urlToGet = getTrackServiceBillingUrl(companyId);
    const respData = await httpGet(urlToGet);
    return respData;
  }
);

export const addCompanySubscriptionData = createAsyncThunk(
  "companyServiceBilling/addCompanySubscriptionData",
  async (data, thunkApi) => {
    const url = addCompanySubscriptionUrl(data);
    const respData = await httpPost(url, data);
    return respData;
  }
);

export const addPromotionalCreditData = createAsyncThunk(
  "companyServiceBilling/addPromotionalCreditData",
  async (data, thunkApi) => {
    const url = addPromotionalCreditUrl();
    const respData = await httpPost(url, data);
    return respData;
  }
);

export const getCompanySubscriptionsData = createAsyncThunk(
  "companyServiceBilling/getCompanySubscriptionsData",
  async (params, thunkApi) => {
    const { companyId } = params;
    const urlToGet = getCompanySubscriptionsUrl(companyId);
    const respData = await httpGet(urlToGet);
    return respData;
  }
);

export const getGoCardlessBillingRequestData = createAsyncThunk(
  "companyServiceBilling/getGoCardlessBillingRequestData",
  async (params, thunkApi) => {
    const urlToGet = getGoCardlessBillingRequestUrl();
    const respData = await httpGet(urlToGet);
    return respData;
  }
);

export const getCompanyLedgerSummaryData = createAsyncThunk(
  "companyServiceBilling/getCompanyLedgerSummaryData",
  async (params, thunkApi) => {
    const { companyId } = params;
    const urlToGet = GetCompanyLedgerSummaryUrl(companyId);
    const respData = await httpGet(urlToGet);
    return respData;
  }
);

export const getCompanyLedgerPurchaseHistoryData = createAsyncThunk(
  "companyServiceBilling/getCompanyLedgerPurchaseHistoryData",
  async (params, thunkApi) => {
    const { companyId } = params;
    const urlToGet = GetCompanyLedgerPurchaseHistoryUrl(companyId);
    const respData = await httpGet(urlToGet);
    return respData;
  }
);

export const getCompanyInvoicesByCompanyIdData = createAsyncThunk(
  "companyServiceBilling/getCompanyInvoicesByCompanyIdData",
  async (params, thunkApi) => {
    const { companyId } = params;
    const urlToGet = getCompanyInvoicesByCompanyIdUrl(companyId);
    const respData = await httpGet(urlToGet);
    return respData;
  }
);

export const updateCompanySubscriptionData = createAsyncThunk(
  "companyServiceBilling/updateCompanySubscriptionData",
  async (data, thunkApi) => {
    const url = updateCompanySubscriptionUrl(data);
    const respData = await httpPost(url, data);
    return respData;
  }
);

export const getCompnayUserCountData = createAsyncThunk(
  "companyServiceBilling/getCompnayUserCountData",
  async (params, thunkApi) => {
    const { companyId } = params;
    const urlToGet = getCompnayUserCountUrl(companyId);
    const respData = await httpGet(urlToGet);
    return respData;
  }
);
export const UpdateCompanySubscriptionSiteLicensesData = createAsyncThunk(
  "companyServiceBilling/UpdateCompanySubscriptionSiteLicensesData",
  async (data, thunkApi) => {
    const url = UpdateCompanySubscriptionSiteLicensesUrl(data);
    const respData = await httpPost(url, data);
    return respData;
  }
);
export const getCompanySubscriptionCostsData = createAsyncThunk(
  "companyServiceBilling/getCompanySubscriptionCostsData",
  async (params, thunkApi) => {
    const { companySubscriptionType } = params;
    const urlToGet = getCompanySubscriptionCostsUrl(companySubscriptionType);
    const respData = await httpGet(urlToGet);
    return respData;
  }
);

export const companyServiceBillingSlice = createSlice({
  name: "companyServiceBilling",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getTrackServiceBillingData.pending, (state) => {
        state.isCompanyServicesBilling = true;
      })
      .addCase(getTrackServiceBillingData.fulfilled, (state, action) => {
        state.isCompanyServicesBilling = false;
        state.companyServicesBilling = action.payload || [];
      })
      .addCase(getTrackServiceBillingData.rejected, (state) => {
        state.isCompanyServicesBilling = false;
        state.companyServicesBilling = [];
      })
      .addCase(addCompanySubscriptionData.pending, (state) => {
        state.addCompanySubscriptionLoading = true;
      })
      .addCase(addCompanySubscriptionData.fulfilled, (state, action) => {
        state.addCompanySubscriptionLoading = false;
      })
      .addCase(addCompanySubscriptionData.rejected, (state) => {
        state.addCompanySubscriptionLoading = false;
      })
      .addCase(getCompanySubscriptionsData.pending, (state) => {
        state.isCompanySubscriptionloading = true;
      })
      .addCase(getCompanySubscriptionsData.fulfilled, (state, action) => {
        state.isCompanySubscriptionloading = false;
        state.companySubscription = action.payload || null;
      })
      .addCase(getCompanySubscriptionsData.rejected, (state) => {
        state.isCompanySubscriptionloading = false;
      })
      .addCase(getGoCardlessBillingRequestData.pending, (state) => {
        state.isGoCardlessRequestLoading = true;
      })
      .addCase(getGoCardlessBillingRequestData.fulfilled, (state, action) => {
        state.isGoCardlessRequestLoading = false;
        state.goCardlessRequestData = action.payload || null;
      })
      .addCase(getGoCardlessBillingRequestData.rejected, (state) => {
        state.isGoCardlessRequestLoading = false;
      })
      .addCase(getCompanyLedgerSummaryData.pending, (state) => {
        state.isCompanyLedgerSummaryloading = true;
      })
      .addCase(getCompanyLedgerSummaryData.fulfilled, (state, action) => {
        state.isCompanyLedgerSummaryloading = false;
        state.companyLedgerSummary = action.payload || null;
      })
      .addCase(getCompanyLedgerSummaryData.rejected, (state) => {
        state.isCompanyLedgerSummaryloading = false;
      })
       .addCase(getCompanyLedgerPurchaseHistoryData.pending, (state) => {
        state.isCompanyLedgerPurchaseHistoryLoading = true;
      })
      .addCase(getCompanyLedgerPurchaseHistoryData.fulfilled, (state, action) => {
        state.isCompanyLedgerPurchaseHistoryLoading = false;
        state.companyPurchaseHistory = action.payload || null;
      })
      .addCase(getCompanyLedgerPurchaseHistoryData.rejected, (state) => {
        state.isCompanyLedgerPurchaseHistoryLoading = false;
      })
      .addCase(getCompanyInvoicesByCompanyIdData.pending, (state) => {
        state.iscompanyInvoicesloading = true;
      })
      .addCase(getCompanyInvoicesByCompanyIdData.fulfilled, (state, action) => {
        state.iscompanyInvoicesloading = false;
        state.companyInvoices = action.payload || null;
      })
      .addCase(getCompanyInvoicesByCompanyIdData.rejected, (state) => {
        state.iscompanyInvoicesloading = false;
      })
      .addCase(updateCompanySubscriptionData.pending, (state) => {
        state.isSubscriptionUpdating = true;
      })
      .addCase(updateCompanySubscriptionData.fulfilled, (state, action) => {
        state.isSubscriptionUpdating = false;
        state.updateCompanySubscription = action.payload || null;
      })
      .addCase(updateCompanySubscriptionData.rejected, (state) => {
        state.isSubscriptionUpdating = false;
      })
      .addCase(getCompnayUserCountData.pending, (state) => {
        state.isCompanySubscriptionloading = true;
      })
      .addCase(getCompnayUserCountData.fulfilled, (state, action) => {
        state.isCompanySubscriptionloading = false;
        state.companyUserCount = action.payload || "";
      })
      .addCase(getCompnayUserCountData.rejected, (state) => {
        state.isCompanySubscriptionloading = false;
      })
      .addCase(UpdateCompanySubscriptionSiteLicensesData.pending, (state) => {
        state.isSubscriptionUpdating = true;
      })
      .addCase(UpdateCompanySubscriptionSiteLicensesData.fulfilled, (state, action) => {
        state.isSubscriptionUpdating = false;
        state.updateCompanySubscriptionForLicenses = action.payload || null;
      })
      .addCase(UpdateCompanySubscriptionSiteLicensesData.rejected, (state) => {
        state.isSubscriptionUpdating = false;
         })
        .addCase(getCompanySubscriptionCostsData.pending, (state) => {
          state.isCompanySubscriptionCostsLoading = true;
        })
        .addCase(getCompanySubscriptionCostsData.fulfilled, (state, action) => {
          state.isCompanySubscriptionCostsLoading = false;
          state.companySubscriptionCosts = action.payload || null;
        })
        .addCase(getCompanySubscriptionCostsData.rejected, (state) => {
          state.isCompanySubscriptionCostsLoading = false;
        });
  },
});

export default companyServiceBillingSlice.reducer;
